var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInOperationProjectMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_62_766)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.000976562 8.57175C-0.000976562 3.83743 3.83694 -0.000488281 8.57126 -0.000488281H21.4277C26.1619 -0.000488281 29.9999 3.83743 29.9999 8.57175V21.4282C29.9999 26.1624 26.1619 30.0004 21.4277 30.0004H8.57126C3.83694 30.0004 -0.000976562 26.1624 -0.000976562 21.4282V8.57175Z",
    fill: "url(#paint0_radial_62_766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.929 23.5168C9.08671 22.5188 6.27165 18.9505 6.43551 14.7682C6.60916 10.2605 10.2607 6.60897 14.7682 6.43532C18.9504 6.2739 22.5188 9.089 23.5166 12.9289C23.8027 14.0344 22.9663 15.113 21.8242 15.113H21.817C21.0146 15.113 20.3273 14.5627 20.122 13.7874C19.5106 11.4834 17.3508 9.80318 14.8293 9.9377C12.2026 10.0771 10.0773 12.2025 9.93785 14.8293C9.80333 17.3509 11.4836 19.5106 13.785 20.1196C14.5603 20.325 15.1107 21.0123 15.1107 21.8146V21.8219C15.1107 22.9641 14.032 23.8029 12.929 23.5168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8525 15.4074C16.9427 15.4074 17.8263 14.5237 17.8263 13.4337C17.8263 12.3436 16.9427 11.4599 15.8525 11.4599C14.7626 11.4599 13.8789 12.3436 13.8789 13.4337C13.8789 14.5237 14.7626 15.4074 15.8525 15.4074Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_62_766",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.9995 30.0004) rotate(-90) scale(30.0009)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#476966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#194440"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62_766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInOperationProjectMarker);
export default __webpack_public_path__ + "static/media/inOperationProjectMarker.3209caea6ae5398509a2b8f82aa49505.svg";
export { ForwardRef as ReactComponent };